<template>
  <div class="system-dic-container layout-padding">
    <el-card shadow="hover" class="layout-padding-auto">
      <div class="system-user-search mb15">
        <el-input
          clearable
          v-model="queryData.key"
          @blur="queryTableData"
          size="small"
          placeholder="请输入"
          style="max-width: 180px"
        >
        </el-input>
        <el-select
          v-model="queryData.Declartiontype"
          @change="queryTableData"
          placeholder="申报类型"
          size="small"
        >
          <el-option
            v-for="item in typeOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="queryData.Declareresult"
          clearable
          @change="queryTableData"
          placeholder="申办状态"
          size="small"
        >
          <el-option
            v-for="item in resultOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-button
          size="small"
          type="primary"
          class="ml10"
          @click="queryTableData"
        >
          <el-icon>
            <ele-Search />
          </el-icon>
          查询
        </el-button>
        <!-- <el-button
          size="small"
          type="success"
          class="ml10"
          @click="onOpenAddDic({})"
        >
          <el-icon>
            <ele-FolderAdd />
          </el-icon>
          新增
        </el-button> -->
      </div>
      <el-table :data="tableData" v-loading="loading" style="width: 100%">
        <el-table-column type="index" label="序号" width="50" />

        <el-table-column
          prop="ApprovlName"
          label="申报人"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="ApprovlIdcard"
          label="身份证"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="SubmissionDate"
          label="申报时间"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="DeclartionType_show"
          label="申报类型"
          show-overflow-tooltip
        ></el-table-column>
        <!-- <el-table-column
          prop="ScoreToal"
          label="总积分"
          show-overflow-tooltip
        ></el-table-column> -->
        <el-table-column
          prop="HandlInstruction"
          label="备注"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="DeclareResult_show"
          label="状态"
          show-overflow-tooltip
        >
          <template #default="scope">
            <el-tag :type="scope.row.DeclareResult_type">{{
              scope.row.DeclareResult_show
            }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="100">
          <template #default="scope">
            <el-button
              size="small"
              text
              type="text"
              @click="gotoPreView(scope.row)"
              >{{ scope.row.DeclareResult === 0 ? "审核" : "预览" }}</el-button
            >
            <el-button
              size="small"
              text
              type="text"
              @click="onRowDel(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        class="mt15"
        :pager-count="5"
        :page-sizes="[10, 20, 30]"
        v-model:current-page="queryData.page"
        background
        v-model:page-size="queryData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <dicDialog
      ref="dicDialogRef"
      :DeclareResult="DeclareResult * 1"
      @refresh="queryTableData()"
    ></dicDialog>
  </div>
</template>

<script>
import {
  GetApprovlByPage,
  DeleteApprovle,
} from "@/api/talentIdentification/talentIdentification";
import dicDialog from "./dialog.vue";
export default {
  name: "userManagement",
  components: { dicDialog },
  data() {
    return {
      loading: false,
      DeclareResult: "",
      tableData: [],
      total: 0,
      queryData: {
        page: 1,
        pageSize: 10,
        key: undefined,
        Declartiontype: 0,
        Declareresult: undefined,
      },
      typeOption: [
        {
          label: "全部",
          value: 0,
        },
        // {
        //   label: "积分人才申报",
        //   value: 1,
        // },
        {
          label: "引进人才申报",
          value: 2,
        },
        {
          label: "企业人才申报",
          value: 3,
        },
      ],
      resultOption: [
        {
          label: "办理中",
          value: 0,
        },
        {
          label: "未通过",
          value: 1,
        },
        {
          label: "已通过",
          value: 2,
        },
      ],
    };
  },
  methods: {
    onRowDel(row) {
      let that = this;
      this.$confirm("是否删除该数据？", "提示", {}).then(() => {
        that.HttpDeleteApprovle({ Arrproleid: row.Id });
      });
    },
    onOpenAddDic(row) {
      this.$refs.dicDialogRef.openDialog(row, "add");
    },
    onOpenEditDic(row) {
      this.$refs.dicDialogRef.openDialog(row, "preview");
    },
    gotoPreView(row) {
      this.DeclareResult = row.DeclareResult;
      this.$refs.dicDialogRef.openDialog(row, "preview");
    },
    queryTableData() {
      let param = {
        ...this.queryData,
        Page: this.queryData.page,
        PageSize: this.queryData.pageSize,
      };
      this.HttpQueryBlogList(param);
    },
    onHandleSizeChange(val) {
      this.queryData.pageSize = val;
      this.queryTableData();
    },
    onHandleCurrentChange(val) {
      this.queryData.page = val;
      this.queryTableData();
    },
    //Http查询字典类型列表
    async HttpQueryBlogList(param) {
      this.loading = true;
      const res = await GetApprovlByPage(param);
      this.loading = false;
      let DeclareResultDic = {
        0: {
          label: "办理中",
          type: "warning",
        },
        2: {
          label: "已通过",
          type: "success",
        },
        1: {
          label: "未通过",
          type: "danger",
        },
      };
      let DeclartionTypeDic = {
        // 1: "积分认定",
        2: "引进认定",
        3: "企业认定",
      };
      if (res.data.status == 200) {
        let raw = res.data.response;
        this.total = raw.dataCount;
        let list = raw.data || [];
        list.forEach((o) => {
          o.DeclareResult_show = DeclareResultDic[o.DeclareResult].label;
          o.DeclareResult_type = DeclareResultDic[o.DeclareResult].type;
          o.DeclartionType_show = DeclartionTypeDic[o.DeclartionType];
          !o.ScoreToal && (o.ScoreToal = "-");
        });
        this.tableData = raw.data;
      } else {
        this.$message.error(res.data.msg);
      }
    },
    async HttpDeleteApprovle(param) {
      const response = await DeleteApprovle(param);
      let res = response.data || {};
      if (res.status == 200) {
        this.queryTableData();
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
  },

  mounted() {
    this.queryTableData();
  },
};
</script>

<style scoped></style>
